const defaults = {
  isSortable: true,
  isEditable: true,
  thStyle: 'width: 25%',
}
const contactFields = [
  {
    ...defaults,
    name: 'name',
    key: 'name',
    label: 'Nama',
    placeholder: 'Nama',
    validation: 'required|max:100,length',
  },
  {
    ...defaults,
    name: 'phone',
    key: 'phone',
    label: 'Nomor Telepon',
    placeholder: 'Nomor Telepon',
    validation: 'required|number|min:6,length|max:15,length',
  },
  {
    ...defaults,
    name: 'position',
    key: 'position',
    label: 'Posisi',
    placeholder: 'Posisi',
    validation: 'required|max:255,length',
  },
  {
    ...defaults,
    name: 'email',
    key: 'email',
    label: 'Email',
    placeholder: 'Email',
    validation: 'optional|email|max:255,length',
  },
]

export default contactFields
